import axios from "axios";

const BASE_URL = "https://cloud.seatable.io/api-gateway/api/v2/dtables";
const BASE_UUID = "f6058011-cd70-403e-bf7c-340a2fd6f10b";
const BASE_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NjcxNzQ0NjQsImR0YWJsZV91dWlkIjoiZjYwNTgwMTEtY2Q3MC00MDNlLWJmN2MtMzQwYTJmZDZmMTBiIiwicGVybWlzc2lvbiI6InJ3Iiwib3JnX2lkIjo2ODc0MCwib3duZXJfaWQiOiIyODc3ODUxMzhjNzI0MWZjOWEwMzA5NTZmOGQ1NWQwZkBhdXRoLmxvY2FsIiwidXNlcm5hbWUiOiIyODc3ODUxMzhjNzI0MWZjOWEwMzA5NTZmOGQ1NWQwZkBhdXRoLmxvY2FsIiwidXNlcl9kZXBhcnRtZW50X2lkc19tYXAiOnsiY3VycmVudF91c2VyX2RlcGFydG1lbnRfaWRzIjpbXSwiY3VycmVudF91c2VyX2RlcGFydG1lbnRfYW5kX3N1Yl9pZHMiOltdfSwiaWRfaW5fb3JnIjoiIn0.GEhhBG8qeXoq0PZDL38Qeh96a29MeDONBcrHLx_WIRk";

export async function seaTableSQL(sql) {
  try {
    const response = await axios.post(
      `${BASE_URL}/${BASE_UUID}/sql/`,
      { sql, convert_keys: true },
      {
        headers: {
          Authorization: `Token ${BASE_TOKEN}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error executing SQL:", error.response?.data || error);
  }
}

export async function getTable(table) {
  try {
    const response = await axios.get(
      `${BASE_URL}/${BASE_UUID}/rows/?table_name=${table}`,
      {
        headers: {
          Authorization: `Token ${BASE_TOKEN}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching table:", error.response?.data || error);
  }
}
